import Ajax from '../js/common/ajax';

export default {
  permission: () => Ajax.get('/merchant/permission'),
  overview: () => Ajax.get('/merchant/overview'),
  customer: {
    page: (p) => Ajax.post('/merchant/customer/page', p),
    save: (d) => Ajax.post('/merchant/customer/save', d),
    update: (d) => Ajax.post('/merchant/customer/update', d),
    resetPassword: (id) => Ajax.get('/merchant/customer/resetPassword/' + id),
    status: (d) => Ajax.post('/merchant/customer/status', d),
    delete: (id) => Ajax.delete('/merchant/customer/delete/' + id),
    accountSets: (id) => Ajax.get('/merchant/customer/accountSets/' + id),
  },
  accountSets: {
    open: (d) => Ajax.post('/merchant/accountSets/open', d),
  },
  grant: {
    do: (d) => Ajax.post('/merchant/grant', d),
    page: (p) => Ajax.post('/merchant/grant/page', p),
  },
  package: {
    list: () => Ajax.get('/merchant/package/list'),
    page: (p) => Ajax.post('/merchant/package/page', p),
    save: (d) => Ajax.post('/merchant/package/save', d),
    delete: (id) => Ajax.delete('/merchant/package/delete/' + id),
  },
  admin: {
    list: () => Ajax.get('/merchant/admin/list'),
    save: (d) => Ajax.post('/merchant/admin/save', d),
    delete: (id) => Ajax.delete('/merchant/admin/delete/' + id),
  },
};
